'use strict';

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createSuper");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var events = require('events');

var toString = require('uint8arrays/to-string');

var constants = require('./constants.js');

var index = require('./utils/index.js');

var unwantEvent = function unwantEvent(cid) {
  return "unwant:".concat(toString.toString(cid.multihash.bytes, 'base64'));
};

var blockEvent = function blockEvent(cid) {
  return "block:".concat(toString.toString(cid.multihash.bytes, 'base64'));
};

var Notifications = /*#__PURE__*/function (_events$EventEmitter) {
  _inherits(Notifications, _events$EventEmitter);

  var _super = _createSuper(Notifications);

  function Notifications(peerId) {
    var _this;

    _classCallCheck(this, Notifications);

    _this = _super.call(this);

    _this.setMaxListeners(constants.maxListeners);

    _this._log = index.logger(peerId, 'notif');
    return _this;
  }

  _createClass(Notifications, [{
    key: "hasBlock",
    value: function hasBlock(cid, block) {
      var event = blockEvent(cid);

      this._log(event);

      this.emit(event, block);
    }
  }, {
    key: "wantBlock",
    value: function wantBlock(cid) {
      var _this2 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!cid) {
        throw new Error('Not a valid cid');
      }

      var blockEvt = blockEvent(cid);
      var unwantEvt = unwantEvent(cid);

      this._log("wantBlock:".concat(cid));

      return new Promise(function (resolve, reject) {
        var onUnwant = function onUnwant() {
          _this2.removeListener(blockEvt, onBlock);

          reject(new Error("Block for ".concat(cid, " unwanted")));
        };

        var onBlock = function onBlock(data) {
          _this2.removeListener(unwantEvt, onUnwant);

          resolve(data);
        };

        _this2.once(unwantEvt, onUnwant);

        _this2.once(blockEvt, onBlock);

        if (options && options.signal) {
          options.signal.addEventListener('abort', function () {
            _this2.removeListener(blockEvt, onBlock);

            _this2.removeListener(unwantEvt, onUnwant);

            reject(new Error("Want for ".concat(cid, " aborted")));
          });
        }
      });
    }
  }, {
    key: "unwantBlock",
    value: function unwantBlock(cid) {
      var event = unwantEvent(cid);

      this._log(event);

      this.emit(event);
    }
  }]);

  return Notifications;
}(events.EventEmitter);

exports.Notifications = Notifications;